// Get Media URL - Return the full distant URL for medias
export function getMediaURL(url) {
  if (url === null || url === undefined) {
    return null
  }

  // Return the full Gatsby URL for static files
  if (url.toString().startsWith('/static')) {
    return url
  }

  // Return the full URL if the media is hosted on an external provider
  if (url.toString().startsWith('http') || url.toString().startsWith('//')) {
    return url
  }

  // Otherwise prepend the URL path with the Media Library URL
  return `${process.env.GATSBY_MEDIA_URL}${url}`
}

